import axios from 'axios';
import { toCamelCase } from '../../utils/object';
import BatchManager from './BatchManager';

const CRITICAL_TIMEOUT = 10000;
const NON_CRITICAL_SERVER_TIMEOUT = 750;
const TIMEOUTERROR = { message: 'Gateway Timeout', status: 504 };

export default ({ baseURL, headers }) => {
  const axiosInstance = axios.create({
    baseURL,
    headers
  });
  axiosInstance.interceptors.response.use(
    res => toCamelCase(res.data),
    (error) => {
      // eslint-disable-next-line no-param-reassign
      error.response = error.code === 'ECONNABORTED'
        ? TIMEOUTERROR
        : error.response;

      return Promise.reject(error);
    }
  );

  const batchManager = new BatchManager(axiosInstance);
  const getBatch = request => batchManager.get(request) || batchManager.create(request);
  const getBatchedResponse = request => getBatch(request).add(request);

  return function apiService(request) {
    const timedRequest = {
      ...request,
      timeout: process.browser || request.isCritical
        ? CRITICAL_TIMEOUT
        : NON_CRITICAL_SERVER_TIMEOUT
    };

    return request.batcher ? getBatchedResponse(timedRequest) : axiosInstance(timedRequest);
  };
};



// WEBPACK FOOTER //
// ./src/universal/ui/services/api/index.js